import { render, staticRenderFns } from "./InvestmentVersionCardContent.vue?vue&type=template&id=e5864f7e&"
import script from "./InvestmentVersionCardContent.vue?vue&type=script&lang=ts&"
export * from "./InvestmentVersionCardContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports